const DataValid = function (data, mustArray = false) {
    if (data !== undefined && data !== null && data !== '') {
        if (mustArray && !Array.isArray(data)) {
            return false;
        } else {
            if (typeof data === 'object') {
                return Object.keys(data).length > 0
            } else if (Array.isArray(data)) {
                return data.length > 0
            }

            if (data.length > 0) {
                return data.trim().length > 0
            }

            return true;
        }
    } else {
        return false;
    }
}

const isAppMode = function (appMode, modes = []) {
    let pass = false
    if (modes.includes(appMode)) {
        pass = true
    } else {
        for (let i = 0; i < modes.length; i++) {
            if (modes[i].indexOf('+') > -1) {
                const number = parseInt(modes[i].substring(0, modes[i].length - 1))
                const modeNumber = parseInt(appMode.substring(1))
                if (!isNaN(modeNumber) && !isNaN(number) && modeNumber > number) {
                    pass = true
                    break
                }
            }
        }
    }

    return pass
}

export default {
    DataValid,
    isAppMode
}